import ForgotComponent from "../components/ForgotPassword";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const imagePaths = {
    logo: './images/ic_logo.svg',
    emailIcon: './images/ic_email.svg',
    passwordIcon: './images/ic_password.svg',
    hidepasswordIcon: './images/ic_eyeclose.svg',
    ic_student: './images/ic_student.svg',
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <ForgotComponent
        imagePaths={imagePaths}
        onResetPassword={(email) => console.log(email)}
        onGoToLogin={() => navigate('/login')}
      />
    </div>

  );
};

export default ForgotPassword;
